import { render, staticRenderFns } from "./TrainingStatsConfirmationView.vue?vue&type=template&id=c95ed0c6&scoped=true&"
import script from "./TrainingStatsConfirmationView.vue?vue&type=script&lang=js&"
export * from "./TrainingStatsConfirmationView.vue?vue&type=script&lang=js&"
import style0 from "./TrainingStatsConfirmationView.vue?vue&type=style&index=0&id=c95ed0c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95ed0c6",
  null
  
)

export default component.exports